module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq705-6f6875e06d79b3a4ef44eef7b866132e.jpg";